import apiClient from "./axios"

// Get all customer departments with optional filtering
export const getCustomerDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/customer-departments", { params })
  return data
}

// Get a specific customer department by ID
export const getCustomerDepartment = async id => {
  const { data } = await apiClient.get(`/customer-departments/${id}`)
  return data
}

// Create a new customer department
export const createCustomerDepartment = async departmentData => {
  const { data } = await apiClient.post("/customer-departments", departmentData)
  return data
}

// Update an existing customer department
export const editCustomerDepartment = async ({ id, ...departmentData }) => {
  const { data } = await apiClient.patch(`/customer-departments/${id}`, departmentData)
  return data
}

// Delete a customer department (soft delete)
export const deleteCustomerDepartment = async id => {
  const { data } = await apiClient.delete(`/customer-departments/${id}`)
  return data
}

// Get all customer departments without pagination
export const getAllCustomerDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/customer-departments", {
    params: { ...params, all: true },
  })
  return data
}

// Search customer departments by name or slug
export const searchCustomerDepartments = async (searchTerm, params = {}) => {
  const { data } = await apiClient.get("/customer-departments", {
    params: { ...params, search: searchTerm },
  })
  return data
}

// Get trashed customer departments
export const getTrashedCustomerDepartments = async (params = {}) => {
  const { data } = await apiClient.get("/customer-departments/trashed", { params })
  return data
}

// Get a customer department by slug
export const getCustomerDepartmentBySlug = async slug => {
  const { data } = await apiClient.get(`/customer-departments/slug/${slug}`)
  return data
}

// Restore a trashed customer department
export const restoreCustomerDepartment = async id => {
  const { data } = await apiClient.post(`/customer-departments/${id}/restore`)
  return data
}
